import React from 'react'
import PropTypes from 'prop-types'

import { ModeLink } from '../../ModeRouter/ModeRouter'
import { useAuth } from '../../AuthProvider/AuthProvider'

import './NavigationDrawerHeader.css'

const NavigationDrawerHeader = ({ onClose }) => {
  const { user, authenticated } = useAuth()
  return authenticated ? (
    <h2 data-testid='drawer-header-user-name' styleName='header'>Hi{user.firstName ? ` ${user.firstName}` : ''}!</h2>
  ) : (
    <React.Fragment>
      <h2 data-testid='drawer-header' styleName='header'>Create Account</h2>
      <p data-testid='drawer-text-after-header' styleName='text'>
        Get your food faster. Save order info and payment details across all of your
        favorite restaurants with a Toast account.
      </p>
      <div styleName='flex'>
        <ModeLink
          data-testid='drawer-button-create-account'
          eventData={{
            category: 'User Account',
            action: 'Create Account',
            label: 'Drawer'
          }}
          style='primaryWide'
          onClick={onClose}
          mode='create'
        >
          Create Account
        </ModeLink>
        <div styleName='spacer' />
        <ModeLink
          data-testid='drawer-button-login'
          eventData={{
            category: 'User Account',
            action: 'Login',
            label: 'Drawer'
          }}
          style='secondaryWide'
          onClick={onClose}
          mode='login'
        >
          Log In
        </ModeLink>
      </div>
    </React.Fragment>
  )
}

NavigationDrawerHeader.propTypes = {
  onClose: PropTypes.func
}

export default NavigationDrawerHeader
